import { render, staticRenderFns } from "./OCopyItemButton.vue?vue&type=template&id=0e8ed217&scoped=true&"
import script from "./OCopyItemButton.vue?vue&type=script&lang=js&"
export * from "./OCopyItemButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8ed217",
  null
  
)

export default component.exports